import { render } from "./ClientsAnalysis.vue?vue&type=template&id=0cda46f6&scoped=true"
import script from "./ClientsAnalysis.vue?vue&type=script&lang=js"
export * from "./ClientsAnalysis.vue?vue&type=script&lang=js"

import "./ClientsAnalysis.vue?vue&type=style&index=0&id=0cda46f6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cda46f6"]])

export default __exports__